import { toast, ToastContainer, Zoom } from 'react-toastify';
import React from 'react';

export default function Toastify({ children, page }) {
  const { flash, errors } = (page?.props || {});
  React.useEffect(() => {
    if (flash || errors) {
      Object.entries(flash).forEach(([key, value]) => {
        try {
          toast[key](value);
        } catch (error) {
          toast.error(value);
        }
      });
    }
  }, [page]);

  return (
    <React.Fragment>
      <ToastContainer
        draggable={false}
        transition={Zoom}
        autoClose={4000}
      />
      { children  }
    </React.Fragment>
  );
}
